<!-- Main Page Start -->
<div class="content-wrapper table-full-bx">
    <div class="page-content"
        *ngIf="allData == undefined || (allData?.totalJobs == 0 && allData?.totalSearches == 0 && allData?.totalUsers == 0)">
        <!-- || (allData?.totalJobs == 0 && allData?.totalSearches == 0 && allData?.totalUsers == 0) -->
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="nodatadiv">
                        <p>No data yet lets add jobs </p>
                        <a class="commonBtn" href="javascript:void(0)" routerLink="/jobs/post-job">Start adding Jobs</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="nodatadiv">
                        <p>No data yet lets add team members </p>
                        <a class="commonBtn" href="javascript:void(0)" routerLink="/users/add">Start adding team
                            members</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="page-content graphs"
        *ngIf="allData?.totalJobs != 0 || allData?.totalSearches != 0 || allData?.totalUsers != 0">
        <div class="ibox">
            <div class="ibox-body">
                <div class="flexbox mb-5">
                    <div class="iboxcontent">
                        <h3> Welcome back, <strong class="capitalize"> {{userDatas?.Recruiter?.name}}! </strong></h3>
                    </div>
                    <div class="input-group-icon input-group-icon-left">
                        <div class="commonBtn2 filter" (click)="openModal(Filter)">
                            <div class="redDot" *ngIf="show == 1"></div>
                            <img src="../../../assets/images/filter-filled-tool-symbol-svgrepo-com.svg">
                        </div>
                    </div>
                </div>
                <!-- stats -->
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="card mb-4">
                            <div class="card-body flexbox-b">
                                <div class="easypie mr-3">
                                    <span class="easypie-data pd-set" style="font-size:28px;"><i><img
                                                src="assets/images/ic_search_black.svg"></i></span>
                                </div>
                                <div>
                                    <div class="text-muted"> Total searches </div>
                                    <h3 class="font-strong"> {{allData?.totalSearches}} </h3>
                                    <small class="green profitLoss" *ngIf="allData?.percentage > 0"><img
                                            src="../../../assets/images/ic_up.svg" /> {{allData?.percentage + "%"}}
                                    </small>
                                    <small class="red profitLoss" *ngIf="allData?.percentage < 0"><img
                                            src="../../../assets/images/ic_loss.svg" /> {{allData?.percentage + "%"}}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="card mb-4">
                            <div class="card-body flexbox-b">
                                <div class="easypie mr-3">
                                    <span class="easypie-data pd-set" style="font-size:28px;"><i><img
                                                src="assets/images/ic_email_sent.svg"></i></span>
                                </div>
                                <div>
                                    <div class="text-muted"> Emails sent </div>
                                    <h3 class="font-strong">{{allData?.emailSendClicks}} </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="card mb-4">
                            <div class="card-body flexbox-b">
                                <div class="easypie mr-3">
                                    <span class="easypie-data pd-set" style="font-size:28px;"><i><img
                                                src="assets/images/ic_email_open.svg"></i></span>
                                </div>
                                <div>
                                    <div class="text-muted"> Emails Forward </div>
                                    <h3 class="font-strong"> {{allData?.emailForwordClicks}} </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="card mb-4">
                            <div class="card-body flexbox-b">
                                <div class="easypie mr-3">
                                    <span class="easypie-data pd-set" style="font-size:28px;"><i><img
                                                src="assets/images/ic_candidate.svg"></i></span>
                                </div>
                                <div>
                                    <div class="text-muted"> Candidate clicks </div>
                                    <h3 class="font-strong"> {{allData?.candidateClicks}} </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- 1 -->
                    <div class="col-md-6 col-12">
                        <div class="ibox inventory-chart">
                            <div class="ibox-head">
                                <div class="ibox-title"> Inventory used by month </div>
                            </div>
                            <div class="ibox-body">
                                <div>
                                    <div id="chart-column" class="demo-chart"></div>
                                </div>
                                <span class="filterYear">year : <span
                                        *ngIf="filterForm.value.startDate ">{{filterForm.value.startDate | date}}
                                        -{{filterForm.value.endDate | date}}</span> <span *ngIf="fromDate == undefined">
                                        {{today | date}}</span></span>
                                <div *ngIf="noDataFound" class="chartBar noDataFound">
                                    <h2> No Data Found</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 2 -->
                    <div class="col-md-6 col-12">
                        <div class="ibox inventory-chart">
                            <div class="ibox-head">
                                <div class="ibox-title"> Top 10 inventory usage users</div>
                            </div>
                            <div class="ibox-body">
                                <div>
                                    <div id="bar-Horizontal" class="chartBar"></div>
                                </div>
                                <span class="filterYear">year : <span
                                        *ngIf="filterForm.value.startDate ">{{filterForm.value.startDate | date}}
                                        -{{filterForm.value.endDate | date}}</span> <span *ngIf="fromDate == undefined">
                                        {{today | date}}</span></span>
                                <div *ngIf="noDataFound" class="chartBar noDataFound">
                                    <h2> No Data Found</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 3 -->
                    <div class="col-md-6 col-12">
                        <div class="ibox inventory-chart">
                            <div class="ibox-head">
                                <div class="ibox-title"> Top 10 users by email sent </div>
                            </div>
                            <div class="ibox-body">
                                <div class="flexbox mb-4">
                                    <div id="bar-Horizontal2" class="chartBar"></div>
                                </div>
                                <span class="filterYear">year : <span
                                        *ngIf="filterForm.value.startDate ">{{filterForm.value.startDate | date}}
                                        -{{filterForm.value.endDate | date}}</span> <span *ngIf="fromDate == undefined">
                                        {{today | date}}</span></span>

                                <div *ngIf="noDataFound" class="chartBar noDataFound">
                                    <h2> No Data Found</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 4 -->
                    <div class="col-md-6 col-12">
                        <div class="ibox inventory-chart">
                            <div class="ibox-head">
                                <div class="ibox-title"> Sent email campaign summary </div>
                            </div>
                            <div class="ibox-body">
                                <div class="flexbox mb-4">
                                    <div id="chart-barLine" class="demo-chart"></div>
                                </div>
                                <span class="filterYear">year : <span
                                        *ngIf="filterForm.value.startDate ">{{filterForm.value.startDate | date}}
                                        -{{filterForm.value.endDate | date}}</span> <span *ngIf="fromDate == undefined">
                                        {{today | date}}</span></span>
                                <div *ngIf="noDataFound" class="chartBar noDataFound">
                                    <h2> No Data Found</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<!-- Filter -->
<ng-template #Filter let-modal>
    <div class="modal-body">
        <h4 class="pageTitle upper">Filter</h4>
        <form [formGroup]="filterForm">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>From Date<i class="text-danger">*</i></label>
                        <input formControlName="startDate" type="text" placeholder="Select From Date"
                            class="form-control" bsDatepicker [bsConfig]="{
                  isAnimated: true,
                  dateInputFormat: 'DD-MM-YYYY',
                  showWeekNumbers: false
                }" [maxDate]="today" />
                        <div class="text-danger" *ngIf="
                  filterForm.controls['startDate'].hasError('required') &&
                  showError
                ">
                            *Please enter valid date.
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label>To Date<i class="text-danger">*</i></label>
                        <input formControlName="endDate" type="text" placeholder="Select To Date" class="form-control"
                            bsDatepicker [bsConfig]="{
                  isAnimated: true,
                  dateInputFormat: 'DD-MM-YYYY',
                  showWeekNumbers: false
                }" [maxDate]="today" />
                        <div class="text-danger" *ngIf="
                  filterForm.controls['endDate'].hasError('required') && showError
                ">
                            *Please enter valid date.
                        </div>
                        <div class="text-danger" *ngIf="invalidDateFilter">
                            *End Date should always be greater than Start Date.
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group text-right">
                <a href="javascript:void(0);" class="planbtn greyBtn"
                    (click)="clearFilter(modal);modalRef?.hide()">Clear</a>
                <input type="submit" value="Apply" class="planbtn fill" (click)="applyFilter(modal)">
            </div>
        </form>
    </div>
</ng-template>